import Vendor from "./vendor";

export default function Contractor({ register, errors }){

    return <Vendor register={register} errors={errors} />;
}
